import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  total: function total(state) {
    return state.total;
  },
  items: function items(state) {
    return state.items;
  },
  success: function success(state) {
    return state.success;
  },
  successServer: function successServer(state) {
    return state.successServer;
  },
  state: function state(_state) {
    return _state.cartState;
  }
};